import HttpError from './HttpError';

export default class CouponExpiredError extends HttpError {}
